<template>
  <div class="wa-alert-flags" role="list" dir="ltr">
    <span
      v-for="flag in flags"
      :key="flag.key"
      class="wa-alert-flag"
      :class="{ 'wa-alert-flag--on': flag.on }"
      role="listitem"
      :title="`${$t(flag.labelKey)}: ${flag.on ? $t('yes') : $t('no')}`"
    >
      {{ flag.abbr }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    workingArea: {
      type: Object,
      required: true,
    },
  },
  computed: {
    flags() {
      const w = this.workingArea
      return [
        { key: 'sms', abbr: 'SMS', labelKey: 'sms', on: !!w.sms },
        { key: 'email', abbr: 'EML', labelKey: 'email', on: !!w.email },
        { key: 'counter', abbr: 'CTR', labelKey: 'counterCalls', on: !!w.counter },
        { key: 'offline_calls', abbr: 'OFF', labelKey: 'offline_calls', on: !!w.offline_calls },
        { key: 'notified', abbr: 'PUSH', labelKey: 'notified', on: !!w.notified },
        { key: 'api', abbr: 'API', labelKey: 'api', on: !!w.api },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.wa-alert-flags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.wa-alert-flag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.2;
  border: 1px solid #e2e6eb;
  background: #f3f5f7;
  color: #9aa3ad;

  &--on {
    border-color: #b8dfc8;
    background: #edf8f1;
    color: #1f6b3f;
  }
}
</style>
